




























import { Vue, Component } from 'vue-property-decorator'
import * as firebase from "firebase";
@Component
export default class Auth extends Vue {
    created(){
        firebase.auth().onAuthStateChanged((user) =>{
            if (user){
                this.$store.dispatch('autoSignIn', user)
            }
        });
    }
}
